const menu = {
  data() {
    return {
      active: false,
    };
  },
  computed: {
    menuActive() {
      return this.route === 'Home' || this.active;
    },
    route() {
      return this.$route.name;
    },
  },
  methods: {
    toggleMenu() {
      this.active = !this.active;
    },
    hideMenu() {
      this.active = false;
    },
  },
  watch: {
    route() {
      this.active = false;
    },
  },
};

export default menu;
